import cx from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";

const LinkInternal = ({
  href,
  children,
  className = "",
  label = "",
  activeClassName = "",
}) => {
  const router = useRouter();

  return (
    <Link href={href} passHref legacyBehavior>
      <a
        className={cx(className, {
          [activeClassName]: router.pathname === href,
        })}
        aria-label={label}
      >
        {children}
      </a>
    </Link>
  );
};

export default LinkInternal;
